import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import Localizer from "@Scripts/Common/Localizer";

@Component({ name: "PageSearchBox" })
export default class PageSearchBox extends Vue {
    public localizer: any = Localizer;
    public search: string = null;
    public placeHolder: string = null;

    get routes() {
        return (<any>window).App.routes;
    }

    @Prop() type: string;

    public mounted() {
        switch (this.type) {
            case "Airline":
                this.placeHolder = this.localizer.get("App.Common.Search_Airline_Placeholder");
                break;
            case "Airport":
                this.placeHolder = this.localizer.get("App.Common.Search_Airport_Placeholder");
                break;
            case "Destination":
                this.placeHolder = this.localizer.get("App.Common.Search_Destination_Placeholder");
                break;
            default:
                this.placeHolder = this.localizer.get("App.Common.Search_Placeholder");
                break;
        }
    }

    public showAll() {
        (<any>window).location = this.routes.Search_List + "?searchtext=" + this.search + "&searchType=" + this.type;
    }
};